import Ajv from "ajv";
import isSvg from "is-svg";
import { validateAge } from "smoldate";
import { validateCPF } from "../config/rimowa/forms/validteCpf";
import { get } from "../utils/helpers";

export const RE_DATE_STRING_HAS_YEAR = /^\d{4}/;

export const CUSTOM_FORMATS = {
  /**
   * Check that the input corresponds to SVG code:
   *
   * ```
   * {
   *   "type": "string",
   *   "format": "svg"
   * }
   * ```
   */
  svg: {
    type: "string",
    async: false,
    validate(input: any): boolean {
      return isSvg(input);
    },
    compare(a: string, b: string): number {
      return a.length === b.length ? 0 : a.length > b.length ? 1 : -1;
    }
  }
};

export const CUSTOM_KEYWORDS = {
  /**
   * Check that a date fulfils a minimum age requirement:
   *
   * ```
   * {
   *   "type": "string",
   *   "format": "date",
   *   "minimumAge": 16
   * }
   * ```
   */

  cpfCustomValidtion: {
    validate(schema: any, data: any, parentSchema?: object) {
      const isValidCPF = validateCPF(data);
      if (isValidCPF) return true;
      return false;
    },
    errors: true
  },

  minimumAge: {
    validate(schema: any, data: any, parentSchema?: object) {
      // Only validate the age if a year has been given

      if (RE_DATE_STRING_HAS_YEAR.test(data)) {
        return (
          !!parentSchema &&
          validateAge(data, parseInt(get(parentSchema, "minimumAge"), 10))
        );
      }

      // Assume that the age is correct if no year given
      return true;
    },
    errors: true
  }
};

// Formats
export function extendAjvCustomFormats(ajv: Ajv.Ajv): void {
  Object.keys(CUSTOM_FORMATS).forEach(formatName => {
    const formatInfo = get(CUSTOM_FORMATS, formatName);
    ajv.addFormat(formatName, formatInfo);
  });
}

// Keywords
export function extendAjvCustomKeywords(ajv: Ajv.Ajv): void {
  Object.keys(CUSTOM_KEYWORDS).forEach(keyword => {
    const keywordFn = get(CUSTOM_KEYWORDS, keyword);
    ajv.addKeyword(keyword, keywordFn);
  });
}

export function extendAjv(ajv: Ajv.Ajv): void {
  extendAjvCustomFormats(ajv);
  extendAjvCustomKeywords(ajv);
}
